import scrollToElement from "../../configurator/modules/scrollToElement";
import { generateLeadEvent } from "../../modules/tracking/AnalyticsEvents";
import flatpickr from "flatpickr";

export default function(form) {
    const validator = new ContactFormValidator({
        element: form,
        hasOverlayingLabels: true,
        redesign: true,
        vueForm: false,
    });

    let dealerIds = false;
    try {
        dealerIds = JSON.parse(form.dataset.dealers);
    } catch (error) {
        console.error('Error parsing dealer IDs to filter by');
    }

    const locationHandler = new CustomerLocationHandler();
    console.log('locationHandler ',locationHandler);
    console.log('Dealer IDs for filtering:', dealerIds);

    if (dealerIds !== false && dealerIds.length > 0) {
        console.log('Setting additional location filter function for dealer IDs:', dealerIds);
        locationHandler.setAdditionalLocationFilterFunction(location => {
            return dealerIds.indexOf(location.id) >= 0;
        });
    }

    locationHandler.setup(form.getAttribute('id'));

    const dealerSelect = form.querySelector('[name="location-id"]');
    const dateInput = form.querySelector('[name="date"]');
    const timeSelect = document.querySelector('[name="time"]');
    const serviceType = 'sales';

    async function fetchAndUpdateTimes() {
        let dealerId = dealerSelect.value;
        let date = null
        if (dateInput) {
            date = dateInput.value;
        }
        if (!date) {
            // Default to Wednesday if no date is set
            const currentDate = new Date();
            const dayOfWeek = currentDate.getDay();
            const daysUntilWednesday = (3 - dayOfWeek + 7) % 7;
            const wednesdayDate = new Date(currentDate);
            wednesdayDate.setDate(currentDate.getDate() + daysUntilWednesday);

            const day = String(wednesdayDate.getDate()).padStart(2, '0');
            const month = String(wednesdayDate.getMonth() + 1).padStart(2, '0');
            const year = wednesdayDate.getFullYear();

            date = `${day}-${month}-${year}`;
        }

        if (dealerId && date) {
            const times = await fetchOpeningTimes(date, dealerId, serviceType);
            updateTimeOptions(times);
        }
    }

    if (dealerSelect) {
        dealerSelect.addEventListener('automatic_change', fetchAndUpdateTimes);
        dealerSelect.addEventListener('change', fetchAndUpdateTimes);
    }

    if (dateInput) {
        // Support both legacy and redesigned markup selectors to avoid breaking
        // the date picker setup when templates are migrated.
        const dateTimeContainer = document.querySelector('.cms-content-form__date-time, .form-date-time');
        let startDate = null;
        let endDate = null;
        if (dateTimeContainer.dataset.limitDates == true) {
            startDate = dateTimeContainer.dataset.startDate;
            endDate = dateTimeContainer.dataset.endDate;

            if (startDate) {
                const [startYear, startMonth, startDay] = startDate.split('-');
                startDate = `${startDay}-${startMonth}-${startYear}`;
            }

            if (endDate) {
                const [endYear, endMonth, endDay] = endDate.split('-');
                endDate = `${endDay}-${endMonth}-${endYear}`;
            }
        }

        const datePicker = flatpickr(dateInput, {
            dateFormat: "d-m-Y",
            minDate: startDate ? startDate : "today",
            maxDate: endDate ? endDate : null,
            disableMobile:true,
        });

        const toggleButton = form.querySelector("#toggle-date-picker");
        if (toggleButton) {
            toggleButton.addEventListener('click', () => {
                if (datePicker.isOpen) {
                    datePicker.close();
                } else {
                    datePicker.open();
                }
            });
        }

        dateInput.addEventListener('change', fetchAndUpdateTimes);
    }

    function updateTimeOptions(times) {
        if (!timeSelect) return;

        timeSelect.innerHTML = '';

        const placeholderOption = document.createElement('option');
        placeholderOption.textContent = "Please select a time";
        placeholderOption.disabled = true;
        placeholderOption.selected = true;
        timeSelect.appendChild(placeholderOption);

        if (Array.isArray(times) && times.length > 0) {
            // Remove the last hour
            times.pop();

            times.forEach(time => {
                const option = document.createElement('option');
                option.value = time;
                option.textContent = time;
                timeSelect.appendChild(option);
            });
        }
    }
    // If there's a brand element, call the passed in handler every time it changes
    const brandElement = form.querySelector('[name="brand"]');
    if (brandElement) {
        brandElement.addEventListener('change', function() {
            locationHandler.updateBrand(this.value);

            if (timeSelect) {
                timeSelect.innerHTML = '';
                const placeholderOption = document.createElement('option');
                placeholderOption.value = '';
                placeholderOption.textContent = 'Please select a time';
                placeholderOption.disabled = true;
                placeholderOption.selected = true;
                timeSelect.appendChild(placeholderOption);
            }
        });

        locationHandler.updateBrand(brandElement.value);
    }

    updateTimeOptions();


    form.addEventListener('submit', async function(e) {
        e.preventDefault();
        if (!await validator.isValid()) {
            return false;
        }

        const formData = new FormData(form);
        formData.append('lat', customerLat);
        formData.append('lng', customerLng);
        validator.preventInput();

        let formName = form.dataset.formName || 'New Vehicle Offers - Enquiry';

        $.ajax({
            type: "POST",
            cache: false,
            processData: false,
            contentType: false,
            dataType: 'json',
            url: form.getAttribute('action'),
            data: formData,
            success: function(response) {
                dataLayer.push({
                    'event': 'trackEvent',
                    'eventCategory': 'New Vehicle Offer',
                    'eventAction': formName,
                    'eventLabel': 'Complete',
                    'eventValue': 0
                });

                let parent = $(form).parent();
                parent.find('.cms-content-heading').hide();
                parent.find('.cms-content-generic-form__content').hide();

                generateLeadEvent('cms_generic_form');
                generateLeadEvent('cms_form_event_combined');

                form.innerHTML = response.message || '<h2>Thank you</h2><p class="nice-text">Your details have been sent to ' + response.name + '.</p>';

                validator.allowInput();
                scrollToElement(form);
            },
            error: function(error) {
                validator.errorResponse(error);
            }
        });

        return false;
    });

    async function fetchOpeningTimes(date, dealerId, serviceType, interval = '60 minutes') {
        try {
            const response = await fetch(`/api/dealer-opening-times?date=${date}&dealer=${dealerId}&service_type=${serviceType}&interval=${interval}`);
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching opening times:', error);
            return [];
        }
    }
}